import { loadRequest, loadSuccess, loadFailure } from './actions';
import { call, put, select } from 'redux-saga/effects';
import api from '../../../service/api';
import Swal from 'sweetalert2';
import { SKW_PREFIX } from '../../../utils/constants';

export function* loadAgrupamentos({ payload }: ReturnType<typeof loadRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}listaDepositantes&token=${state.auth.token}`,
      { inscricoesEstaduais: payload.inscricoesEstaduais }
    );

    yield put(loadSuccess(response.data?.depositantes));
  } catch (error: any) {
    yield put(loadFailure());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao carregar o agrupamento, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}
